const ITEMS = [
	"設定いただいた内容は後から変更可能ですが、変更の反映には数日〜数週間かかります。", //
	"必須オプションが紐づけられているプランは連携できません。",
	"OTAとも連携している場合は、ゲストがOTAの掲載価格と比較する際に自社予約を選択しやすいよう、安値のプラン・部屋を設定されることをおすすめします。",
	"複数事業を運営している宿泊施設（泊まれる○○、宿坊など）の場合、事業ごとにGoogleビジネスプロフィールを作成し、宿泊施設用のGoogleビジネスプロフィールを用意した上で連携設定を行ってください。",
];

export const SettingsManagement = () => {
	return (
		<div className="space-y-2">
			<h5 className="text-base font-bold">設定に関する注意点</h5>
			<div className="bg-bg-layer-100 rounded p-4">
				<div className="space-y-4">
					<ul className="list-outside list-disc space-y-2 text-sm font-medium">
						{ITEMS.map((item) => (
							<li key={item}>{item}</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};
